import { Component, Input } from '@angular/core';
import {
  confidenceTier,
  SmartLinkTier,
} from 'src/app/core/models/i-smart-link';

const TIER_STYLES: Record<
  SmartLinkTier,
  { fillClass: string; textClass: string }
> = {
  Strong: {
    fillClass: 'bg-brand-blue-dark-3',
    textClass: 'text-brand-blue-dark-3',
  },
  Possible: {
    fillClass: 'bg-brand-blue-dark-1',
    textClass: 'text-brand-blue-dark-1',
  },
  Weak: {
    fillClass: 'bg-gray-400',
    textClass: 'text-gray-400',
  },
};

@Component({
  selector: 'app-smart-link-strength',
  templateUrl: './smart-link-strength.component.html',
  styleUrls: ['./smart-link-strength.component.scss'],
})
export class SmartLinkStrengthComponent {
  @Input() confidence: number;

  get tier(): SmartLinkTier {
    return confidenceTier(this.confidence);
  }

  get fillClass(): string {
    return TIER_STYLES[this.tier].fillClass;
  }

  get textClass(): string {
    return TIER_STYLES[this.tier].textClass;
  }

  // Rounded once for both the bar and the label, or they disagree by a point at every .x95.
  get fillPercent(): number {
    return Math.round(this.confidence * 100);
  }

  get confidenceLabel(): string {
    return `${this.fillPercent}%`;
  }

  get ariaLabel(): string {
    return `${this.tier} match, confidence ${this.confidenceLabel}`;
  }
}
